import * as ambassadorWixAcademyCertificationsV1UserCertification from './academy-certifications-v1-user-certification-user-certifications.http.js';
import * as ambassadorWixAcademyCertificationsV1UserCertificationTypes from './academy-certifications-v1-user-certification-user-certifications.types.js';
import * as ambassadorWixAcademyCertificationsV1UserCertificationUniversalTypes from './academy-certifications-v1-user-certification-user-certifications.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getUserCertification(): __PublicMethodMetaInfo<
  'GET',
  { userCertificationId: string },
  ambassadorWixAcademyCertificationsV1UserCertificationUniversalTypes.GetUserCertificationRequest,
  ambassadorWixAcademyCertificationsV1UserCertificationTypes.GetUserCertificationRequest,
  ambassadorWixAcademyCertificationsV1UserCertificationUniversalTypes.GetUserCertificationResponse,
  ambassadorWixAcademyCertificationsV1UserCertificationTypes.GetUserCertificationResponse
> {
  const payload = { userCertificationId: ':userCertificationId' } as any;

  const getRequestOptions =
    ambassadorWixAcademyCertificationsV1UserCertification.getUserCertification(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/user-certifications/{userCertificationId}',
    pathParams: { userCertificationId: 'userCertificationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  UserCertification as UserCertificationOriginal,
  CertificationType as CertificationTypeOriginal,
  CertificationTypeWithLiterals as CertificationTypeWithLiteralsOriginal,
  CreateUserCertificationRequest as CreateUserCertificationRequestOriginal,
  CreateUserCertificationResponse as CreateUserCertificationResponseOriginal,
  GetUserCertificationRequest as GetUserCertificationRequestOriginal,
  GetUserCertificationResponse as GetUserCertificationResponseOriginal,
  DeleteUserCertificationRequest as DeleteUserCertificationRequestOriginal,
  DeleteUserCertificationResponse as DeleteUserCertificationResponseOriginal,
  QueryUserCertificationsRequest as QueryUserCertificationsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryUserCertificationsResponse as QueryUserCertificationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './academy-certifications-v1-user-certification-user-certifications.types.js';
